import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Award, KeyRound, CalendarClock, Megaphone, ClipboardList } from "lucide-react";
import { ADMIN_TRAIN } from "@/constants/testIds";

const CARDS = [
  { to: "/admin/training/modules", icon: BookOpen, label: "Modules & tracks", blurb: "Create, edit, version learning content per track." },
  { to: "/admin/access-codes",     icon: KeyRound, label: "Access codes",     blurb: "Invite codes, role restrictions, system-default control." },
  { to: "/admin/certifications",   icon: Award, label: "Certifications",     blurb: "All issued credentials. Revoke if needed." },
  { to: "/admin/seminars",         icon: CalendarClock, label: "Seminars",   blurb: "Schedule live sessions per track or for everyone." },
  { to: "/admin/announcements",    icon: Megaphone, label: "Announcements",  blurb: "Broadcast to learners (all / specific roles or tracks)." },
  { to: "/admin/training/access-logs", icon: ClipboardList, label: "Access logs", blurb: "Every code redemption — success and failure." },
];

export default function AdminTrainingHome() {
  return (
    <div data-testid={ADMIN_TRAIN.home} className="space-y-8">
      <header className="fade-up">
        <div className="eyebrow">Training admin</div>
        <h1 className="headline-xl">Lifted Academy control</h1>
        <p className="text-lifted-dim mt-2 max-w-2xl">
          Tracks, certifications, access codes and announcements for affiliates, drivers, partners and franchisees.
        </p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c, i) => (
          <Link key={c.to} to={c.to} className={`glass-panel p-6 fade-up delay-${(i % 5) + 1} hover:-translate-y-1 hover:border-lifted-green/30 transition-transform`}>
            <div className="flex items-center gap-4">
              <div className="h-11 w-11 rounded-xl border border-lifted-green/30 bg-lifted-green/10 text-lifted-green flex items-center justify-center">
                <c.icon className="h-5 w-5" />
              </div>
              <div>
                <div className="font-anton text-xl uppercase">{c.label}</div>
                <div className="text-sm text-lifted-dim">{c.blurb}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
